import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import React from 'react';
import TaskDiscussion from "../../taskManager/task-discussion";

const DiscussDocTask = ({ onClose, task, documentId, authorStaffId }) => {
    return (
        <Dialog onClose={onClose} title={"Task"} className="task-modal-mainn width_90 small-dialog xl-modal" width={"60%"} height={"90%"} >
            <TaskDiscussion
                task={task}
                documentId={documentId}
                authorStaffId={authorStaffId}
            />
            <DialogActionsBar>
                <div className="preview-btn-bottom mt-5 background-color">  
                    <hr className="my-2"></hr>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base px-4 textWhite"
                    onClick={onClose} >
                    Close
                </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}

export default DiscussDocTask